import React, { createRef, useEffect, useState } from 'react'
import { useParams, useLocation, Link } from 'react-router-dom'
import Projects from '../components/Projects.json'
import Spinner from '../components/Spinner'
import img from '../assets/Johnson Courthouse Photo.jpg'

export default function ViewProjects(props) {
    /*
    {
        "id": 17,
        "title": "",
        "projNum": "",
        "projLen": "",
        "projCost": "",
        "existingCon": "",
        "projDesc": "",
        "map": "/assets/projects/"
    }    
    */

    const { id } = useParams();
    const [projNum, setProjNum] = useState('')
    const [title, setTitle] = useState('')
    const [projLen, setProjLen] = useState('')
    const [projType, setProjType] = useState('')
    const [existingCon, setExistingCon] = useState('')
    const [projDesc, setProjDesc] = useState('')
    const [map, setMap] = useState('')

    const [error, setError] = useState(false)
    const [loading, setLoading] = useState(true)
    const ref = createRef();
    const { pathname } = useLocation();
    const path = pathname.split("/")

    useEffect(() => {
        var data = null;

        for (let i = 0; i < Projects.length; i++) {
            if (id == Projects[i].id) {
                data = Projects[i]
            }
        }
        if (data == null) {
            setError(true)
        }


        setProjNum(data.projNum)
        setTitle(data.title)
        setExistingCon(data.existingCon)
        setProjLen(data.projLen)
        setProjType(data.projType)
        setProjDesc(data.projDesc)
        setMap(data.map)

        setLoading(false)

    }, [id]);


    if (path[1].toLowerCase() === 'viewprojects') {
        if (isNaN(path[2])) return (window.location.href = "/NotFound")
        const projId = parseInt(path[2])
        if (projId < 1) return (window.location.href = "/NotFound")
    }

    if (loading) {
        return (<main className='flex-shrink-0 modular min-vh-100'><Spinner padding={5} /></main>)
    }

    if (error) {
        return (<main className='flex-shrink-0 modular min-vh-100'><div>Page Not Found</div></main>)
    }

    return (
        <div>
            <main className='flex-shrink-0 modular min-vh-100'>
                <div style={{ position: "relative", width: "100%" }}>
                    <img
                        src={img}
                        className="d-block w-100"
                        style={{ objectFit: "cover", height: "175px" }}
                    />
                    <div style={{
                        position: "absolute",
                        top: "50%",
                        left: "0",
                        right: "0",
                        transform: "translateY(-50%)",
                        textAlign: "left",
                    }}>
                        <div className="container">
                            <h5 id="bannerText">Project {projNum}</h5>
                            <h1 style={{ fontWeight: '600', fontSize: 'clamp(0.8rem, 3vw, 2.5rem)' }} id="bannerText">
                                {title}
                            </h1>
                        </div>
                    </div>
                </div>
                <div className="container py-4 text-center">
                    <div ref={ref} id='project' className="row my-2 text-start ">
                        <div className='col-lg-6'>
                            <div className='card shadow'>
                                <div className='card-body'>
                                    <img src={map} className='w-100' />
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-6'>
                            <div className='card shadow mb-3'>
                                <div className='card-body'>
                                    <p>
                                        <h6 style={{ display: 'inline-block', paddingRight: '5px', marginBottom: '0px' }}>Highway / Limits: </h6>
                                        {title}
                                    </p>
                                    <p>
                                        <h6 style={{ display: 'inline-block', paddingRight: '5px', marginBottom: '0px' }}>Project Type: </h6>
                                        {projType}
                                    </p>
                                    {projLen.length > 0 ? <p>
                                        <h6 style={{ display: 'inline-block', paddingRight: '5px', marginBottom: '0px' }}>Project Length: </h6>
                                        {projLen}
                                    </p> : <></>}
                                    <div className='row'>
                                        <h6>Existing Conditions:</h6>
                                        <p>
                                            {existingCon}
                                        </p>
                                    </div>
                                    <div className='row'>
                                        <h6>Proposed Project Description:</h6>
                                        <p style={{ marginBottom: '0px' }}>
                                            {projDesc}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>


                    </div>
                    <div className='mt-4'>
                        <Link to="/projects" style={{ textDecoration: "none" }}>
                            <div className='btn btn-outline-secondary btn-sm'>Back to Projects</div>
                        </Link>
                    </div>

                </div>

            </main>
        </div>
    )
}